"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyFormatter = void 0;
const currencyFormatter = (currency, value, simplify) => {
    const has_decimal_places = value % 1 !== 0;
    switch (currency) {
        case "JPY":
            if (simplify) {
                return `¥ ${value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}`;
            }
            return `¥ ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "THB":
            return `฿${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "AED":
            return `AED ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "SGD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} SGD`;
        case "MYR":
            return `RM ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "USD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} USD`;
        case "IDR":
            if (simplify) {
                return `Rp ${value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}`;
            }
            return `Rp ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "CNY":
            return `¥ ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "AUD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} AUD`;
        case "CAD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} CAD`;
        case "EUR":
            return `€${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
                currency: "EUR",
            })}`;
        case "HKD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} HKD`;
        case "INR":
            return `₹ ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "SAR":
            return `SAR ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "NZD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} NZD`;
        case "DKK":
            return `kr. ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "PHP":
            return `₱ ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "NOK":
            return `kr ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "ZAR":
            return `R ${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "SEK":
            return `${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} kr`;
        case "TWD":
            return `$${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })} TWD`;
        case "GBP":
            return `£${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })}`;
        case "KRW":
            return `₩${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
        case "CHF":
            return `${value.toLocaleString("en-US", {
                maximumFractionDigits: has_decimal_places ? 2 : 0,
                minimumFractionDigits: has_decimal_places ? 2 : 0,
            })} CHF`;
        case "VND":
            // return value as million eg. 1.19M if simplify
            if (simplify) {
                return `VND ${value.toLocaleString("en-US", {
                    notation: "compact",
                    maximumFractionDigits: 2,
                    minimumFractionDigits: 2,
                })}`;
            }
            return `VND ${value.toLocaleString("en-US", {
                maximumFractionDigits: 0,
                minimumFractionDigits: 0,
            })}`;
    }
};
exports.currencyFormatter = currencyFormatter;
